export const ACTIONS = {
    PAN_LEFT: "panleft",
    PAN_RIGHT: "panright",
    SWIPE_LEFT: "swipeleft",
    SWIPE_RIGHT: "swiperight"
};
